import React from 'react';
import { Box, Icon, SpaceBetween } from '@amzn/awsui-components-core';

interface CostChangeIndicatorProps {
  current: number;
  previous: number;
}

export const CostChangeIndicator: React.FC<CostChangeIndicatorProps> = ({ current, previous }) => {
  if (!previous || current === previous) return null;
  const change = ((current - previous) / previous) * 100;
  const isIncrease = change > 0;
  const absoluteChange = Math.abs(Math.round(change));
  if (absoluteChange === 0) return null;

  return (
    <Box margin={{ top: 'm' }}>
      <SpaceBetween direction="horizontal" size="xxs" alignItems="center">
        <Icon name={isIncrease ? 'caret-up-filled' : 'caret-down-filled'} variant={isIncrease ? 'error' : 'success'} />
        <Box fontSize="body-s" color={isIncrease ? 'text-status-error' : 'text-status-success'}>
          {`${absoluteChange}% ${isIncrease ? 'increase' : 'decrease'} from last month`}
        </Box>
      </SpaceBetween>
    </Box>
  );
};
